export const modalPlaces = {
	message:
		"Use the table below to activate and deactivate the tax {{ groupOrProfile }} in your organization",
	group: "Group",
	profile: "Profile",
	title: "Places linked to the tax {{ groupOrProfile }}: {{ name }}",
	searchPlace: "Search for a place",
	placesAt: "Places at",
};
